export default __webpack_public_path__ + "95b07aeac587eaf4fdc01254af1f4a6c.png";